module.exports = __webpack_public_path__ + "img/button_panic.5bc601dc.svg";